/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Demands_Col_DemandInputs */

const cs_demands_col_demand = /** @type {(inputs: Demands_Col_DemandInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Poptávka`)
};

const en_demands_col_demand = /** @type {(inputs: Demands_Col_DemandInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Demand`)
};

/**
* | output |
* | --- |
* | "Demand" |
*
* @param {Demands_Col_DemandInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const demands_col_demand = /** @type {((inputs?: Demands_Col_DemandInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Demands_Col_DemandInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_demands_col_demand(inputs)
	return cs_demands_col_demand(inputs)
});